import React from 'react';
import { Waypoint } from 'react-waypoint';

interface BrandBucketProps {
    middleImage?: string;
    middleSmallImage?: string;
}

export class BrandBucket extends React.PureComponent<BrandBucketProps> {
    state = {
        visible: false,
    };

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    render() {
        const { middleImage, middleSmallImage } = this.props;

        let content = (
            <div
                className="
                    content-bucket
                    branding-image-container
                    branding-image-container__middle
                    eds-l-mar-vert-10
                    eds-l-sw-mar-vert-10
                    eds-l-sm-mar-vert-10
                    eds-l-sn-mar-vert-10
                    eds-align--center-horizontal
                "
            >
                <img
                    srcSet={`
                        ${middleSmallImage} 512w,
                        ${middleImage} 1272w
                    `}
                    sizes="
                        (max-width: 512px) 100vw,
                        1272px
                    "
                    src={middleImage}
                    alt=""
                    className="branding-image-container__middle-image"
                />
            </div>
        );

        if (!this.state.visible) {
            content = <div />;
        }

        return (
            <Waypoint onEnter={this._handleWaypointEnter}>{content}</Waypoint>
        );
    }
}
